import React, { forwardRef, useCallback, useMemo, useState } from 'react'
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import LaceworkMappingForm from './LaceworkMappingForm';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { Divider } from "antd";
import _ from "lodash";
import { useFeatureFlag } from 'contexts/FeatureFlagContext';

const TYPE = {
    apiEndPoint: 'apiEndPoint',
    bucket: 'bucket', 
}

function LaceworkCredentialsForm(props, ref) {
    const featureFlags = useFeatureFlag();
    const isS3FlowEnabled = featureFlags.DEPRECATED_LACEWORK_S3_FLOW_ENABLED;
    const [type, setType] = useState(_.isNull(props.config?.bucketName) ? TYPE.apiEndPoint : TYPE.bucket);

    const handleRadioChange = useCallback((e) => {
        setType(e.target.value);
    },[]);

    const apiEndpointFields = useMemo(()=>([
    {
        name: "apiEndpoint",
        label: "Lacework Organization Endpoint",
        required: true,
        rules: [urlRegexValidator()],
    },
    {
        name: "keyId",
        label: "Key Id",
        required: true,
    },
    {
        name: "secret",
        label: "Secret Key",
        required: true,
        type: FieldTypes.PASSWORD,
    }
    ]),[]);


    const bucketFields = useMemo(() => ([{
        name: "bucketName",
        label: "S3 Bucket Name",
        required: true,
    },
    {
        name: "region",
        label: "Region",
        required: true,
    },{
        name: "roleArn",
        label: "Role",
        required: true,
    },{
        name: "externalId",
        label: "External Id",
        required: true,
    },
    {
        render:() => <Divider type="horizontal" className="m-y-m"/>
    },
    ...apiEndpointFields
    ]),[apiEndpointFields]);

    const configFields = type === TYPE.apiEndPoint ?  apiEndpointFields : bucketFields;

    const fields = useMemo(() => {
        if (!isS3FlowEnabled) {
            return [...apiEndpointFields];
        }
        return [
            {
                name: "authenticationType",
                type: FieldTypes.RADIO,
                options: [
                    {
                        label: 'Bucket (Deprecated)',
                        value: TYPE.bucket
                    },
                    {
                        label: 'API Endpoint',
                        value: TYPE.apiEndPoint
                    }
                ],
                props: {
                    onChange: handleRadioChange,
                    defaultValue: type
                }
            },
            ...configFields,
        ];
    }, [configFields, type, handleRadioChange, isS3FlowEnabled, apiEndpointFields]);

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={LaceworkMappingForm}
            initialValue={{authenticationType: type, apiEndpoint: "https://<organization>.lacework.net"}}
        />
    )
}

export default forwardRef(LaceworkCredentialsForm);